import * as React from 'react';
import * as UI from './style';

interface IInputGroupProps {
  dataAt: string;
  label?: string | React.ReactChild;
  addGap?: number;
  disabled?: boolean;
  className?: string;
  tooltipContent?: string;
  error?: string;
  id?: string;
}

// tslint:disable-next-line:variable-name
const InputGroup: React.FC<IInputGroupProps> = (props) => {
  const gapElements = [];
  if (props.addGap) {
    for (let i = 0; i < props.addGap; i++) {
      gapElements.push(<UI.SInputGap key={`gap_${i}`} className="inputInGroup" />);
    }
  }

  return (
    <UI.SInputGroup id={`input-group-section-${props.id}`} className={props.className}>
      <UI.SInputGroupTitle>{props.label && <UI.SInputLabel>{props.label}</UI.SInputLabel>}</UI.SInputGroupTitle>

      {props.children}

      <UI.SErrorMessage
        className={`${props.dataAt}-Error ${!props.error && 'empty'}`}
        data-at={`${props.dataAt}-Error`}
        error={props.error || ''}
      >
        {props.error}
      </UI.SErrorMessage>
    </UI.SInputGroup>
  );
};

export default InputGroup;
